/**
 * 格式化地址参数
 */
const formatUrl = (str = location.href.split('?')[1]) => {
    const _str = decodeURIComponent(str)
    const arrs = _str.split('?')
    let params = {}
    arrs.map(item => {
        if (item) {
            const _item = item.split('&')
            _item.map(param => {
                const paramsItem = param.split('=')
                params[paramsItem[0]] = paramsItem[1]
            })
        }
    })
    return params
}

export default formatUrl

